const tenancyGetters = {
  // tenancy part
  availableModules: (state) => {
    return [...state.availableModules]
  },
  tenancyEnabled: (state) => {
    return state.tenancyEnabled
  },
  tenantId: (state) => {
    return state.tenantId
  },
  tenantModules: (state) => {
    return state.tenantModules
  },
  tenantConfig: (state) => {
    return state.tenantConfig
  },
  isModuleEnabled: (state) => (moduleSlug) => {
    if (!moduleSlug) return false
    if (moduleSlug === 'dashboard') return true

    const normalized = moduleSlug.replace(/_/g, '-')
    const underscore = moduleSlug.replace(/-/g, '_')
    const camelCase = moduleSlug.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
    const kebabCase = moduleSlug.replace(/([A-Z])/g, '-$1').toLowerCase()
    const isEnabled = (module) => {
      if (!module) return false
      if (module.enabled !== undefined) return module.enabled === true
      if (module.active !== undefined) {
        return module.active === true || module.active === 1 || module.active === '1'
      }
      return true
    }
    const moduleCandidates = [
      state.modulesBySlug?.[moduleSlug],
      state.modulesBySlug?.[normalized],
      state.modulesBySlug?.[underscore],
      state.modulesBySlug?.[camelCase],
      state.modulesBySlug?.[kebabCase],
      state.tenantModules?.[moduleSlug],
      state.tenantModules?.[normalized],
      state.tenantModules?.[underscore],
      state.tenantModules?.[camelCase],
      state.tenantModules?.[kebabCase]
    ]

    return moduleCandidates.some((module) => isEnabled(module))
  },
  modulesBySlug: (state) => {
    return state.modulesBySlug || {}
  },
  userPermissions: (state) => {
    return state.userPermissions || []
  },
  getModuleConfig:
    (state) =>
    (moduleSlug, configKey, defaultValue = null) => {
      if (!state.modulesBySlug || !state.modulesBySlug[moduleSlug]) {
        return defaultValue
      }
      const module = state.modulesBySlug[moduleSlug]
      return module.config && module.config[configKey] !== undefined ? module.config[configKey] : defaultValue
    }
}

export { tenancyGetters }
